import React from "react";
import "../assets/css/NewHeader.css";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import scroller from "react-scroll/modules/mixins/scroller";
import animateScroll from "react-scroll/modules/mixins/animate-scroll";


export default function NewHeader() {
  const scrollType = {
    duration: 500,
    delay: 50,
    smooth: true,
    offset: -50,
};

const onScrollAbout = () => {
    scroller.scrollTo('About', scrollType);
}
const onScrollProjects = () => {
  scroller.scrollTo('Projects', scrollType);
}
const onScrollContact = () => {
  scroller.scrollTo('Contact', scrollType);
}

const onClickUp = () => {
  animateScroll.scrollToTop();
}

const handleResume = () => {
  fetch('nahuel-orselli.pdf').then(response => {
    response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'nahuel-orselli.pdf';
        alink.click();
    })
})
}

  return (
    <>
      <div className="NewHeader">
        <div className="NewHeader-container">
          <Link onClick={()=>onClickUp()} to="/">
            <Logo></Logo>
          </Link>
          <div className="NewHeader-nav">
              <nav className="NewHeader-nav">
                <ul className="NewHeader-ul">
                  <li
                    onClick={()=>onScrollAbout()}
                    className= "NewHeader-li"
                  >
                    About
                    <span className="NewHeader-span"></span>
                  </li>
                  
                  <li
                  onClick={()=>onScrollProjects()}
                  className="NewHeader-li"
                  >
                    Projects
                    <span className="NewHeader-span"></span>
                  </li>
                  <li
                  onClick={()=>onScrollContact()}
                    className= "NewHeader-li"
                  >
                    Contact
                    <span className="NewHeader-span"></span>
                  </li>
                  <li
                    className= "NewHeader-li"
                    onClick={handleResume}
                  >
                    Resume
                    <span className="NewHeader-span"></span>
                  </li>
                </ul>
              </nav>
          </div>
        </div>
      </div>
    </>
  );
}
